/**
 * formr.ts - Formr (Form Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const formrModule = {
  id: 'ui-formr',
  name: 'Form Management',
  icon: '📝',
  category: 'modules',
  order: 14,
  
  packageInfo: {
    name: '@opcentral/formr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Form definition and management system for OpCentral',
    status: 'in-progress',
    implementationProgress: 60,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/validatr': '*',
      'react': '^18.0.0'
    },
    keywords: ['forms', 'validation', 'input', 'ui'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    autoSave: {
      type: 'boolean',
      label: 'Auto-Save Forms',
      description: 'Automatically save form data',
      defaultValue: true
    },
    
    autoSaveInterval: {
      type: 'number',
      label: 'Auto-Save Interval (seconds)',
      description: 'How often to auto-save',
      defaultValue: 30,
      min: 10,
      max: 300,
      visible: (settings) => settings['ui-formr.autoSave']
    },
    
    validateOnBlur: {
      type: 'boolean',
      label: 'Validate on Blur',
      description: 'Validate fields when focus leaves',
      defaultValue: true
    },
    
    showRequiredIndicators: {
      type: 'boolean',
      label: 'Show Required Indicators',
      description: 'Mark required fields visually',
      defaultValue: true
    }
  }
};

export default formrModule;
